//Node imports
import { IEvent } from "@quest/adapter-interface";
import { SlotConstantsBehavior, RetriggerView } from "@quest/murka-games-behavior-leopard/dist";
import { Container, ingenuity } from "@quest/base-core/dist";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
export class RetriggerViewGame extends RetriggerView {
  private reTriggerContainer: Container;
  constructor(json:any){
    super(json);
    this.scaleComponents();
  }
  /**
   * Function overrided to initialize game specific components
   */
  protected initializeComponents(): void {
    super.initializeComponents();
    this.reTriggerContainer = this.getContainerByID("WinTextAndManContainer");
  }

  /**
   * Overrided to change view properties for mobile
   */
  protected resize(evt: IEvent): void {
    super.resize(evt);
    this.x = innerWidth / 2;
    this.y = innerHeight / 2;
    this.setViewProperties();
  }

  /**
   * Function overrided to update view properties of retrigger banner
   */
  protected setViewProperties(): void {
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      let scale = 0;
      this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
      scale = Math.max((innerHeight / ingenuity.configData.width), (innerWidth / ingenuity.configData.height));
      this.getContainerByID("retriggerBGSpineContainerPortrait").scale.set(scale);
      if (ingenuity.deviceEnv.getIsIpad()) {
        this.getContainerByID("retriggerSpineContainerPortrait").scale.set(ingenuity.deviceEnv.getPortraitMaxScale());
      } else {
        this.getContainerByID("retriggerSpineContainerPortrait").scale.set(ingenuity.deviceEnv.getPortraitScale());
      }
      this.scale.set(1);
    }
    else {
      this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
      if (ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER);
      }
      const heightScale = innerHeight / ingenuity.configData.height;
      this.scale.set(heightScale);
      this.scaleComponents();
    }
  }

  /**
   * Method overrided to update scale on retrigger banner
   */
  private scaleComponents() {
    const heightScale = innerHeight / ingenuity.configData.height;
    const widthScale = innerWidth / ingenuity.configData.width;
    if (this.reTriggerContainer) {
      if (widthScale < heightScale) {
        const finalScale = widthScale / heightScale;
        this.reTriggerContainer.scale.set(finalScale);
      }
      else {
        this.reTriggerContainer.scale.set(1);
      }
    }
  }
}

